// extracted by mini-css-extract-plugin
export default {"selectedRow":"tabulator_selectedRow__rfUN1","loaderWrapper":"tabulator_loaderWrapper__Rpenv","loader":"tabulator_loader__FVq+y","spin":"tabulator_spin__rc3d1"};